import UserSelector from './UserSelector'

UserSelector.install = function (Vue) {
  Vue.component(UserSelector.name, UserSelector)
}

export default UserSelector
